// extracted by mini-css-extract-plugin
module.exports = {"carousel":"Carousel_carousel__3SFR-","item":"Carousel_item__85kXO","artists":"Carousel_artists__1Zu9a","albums":"Carousel_albums__17bTq"};